module.exports = __webpack_public_path__ + "static/media/insta2.a721f82d.png";